import { createSetState } from '@flowus/common/zustand/utils';
import { create } from 'zustand';
import type { PageActivitiesType } from './type';

export const $pageActivities = create<PageActivitiesType>(() => ({}));
export const $setPageActivities = createSetState($pageActivities);
